import { render, staticRenderFns } from "./AdditiveContactField.vue?vue&type=template&id=f0e4b53a&"
import script from "./AdditiveContactField.vue?vue&type=script&lang=js&"
export * from "./AdditiveContactField.vue?vue&type=script&lang=js&"
import style0 from "./AdditiveContactField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports